import { render, staticRenderFns } from "./ChanMarketPanel.vue?vue&type=template&id=972d4950&scoped=true"
import script from "./ChanMarketPanel.vue?vue&type=script&lang=js"
export * from "./ChanMarketPanel.vue?vue&type=script&lang=js"
import style0 from "./ChanMarketPanel.vue?vue&type=style&index=0&id=972d4950&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "972d4950",
  null
  
)

export default component.exports